// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-4478b511] {\n  border: 2px solid #2669a0;\n  border-radius: 0.4em;\n}", ""]);
// Exports
module.exports = exports;
